// @flow

import gql from 'graphql-tag';

export default gql`
  fragment serviceMetadata on Service {
    ageInDays
    authType
    hasUpfrontFields
    banner
    isBeta
    isBuiltIn
    isDeprecated
    isFeatured
    isHidden
    isPremium
    isPublic
    isInvite
    isUpcoming
    popularity
    primaryColor
  }
`;
